export default __webpack_public_path__ + "static/quick_bg_1_tn-5f9d092a2bd8d9578e4113e68cdd7794.png";